import React from "react";
import {
    BreakoutItemBarInner,
    BreakoutItemBarOuter,
} from "../Styled/RetailMatchIntroStyles";

interface IRetailMatchBreakoutItemBarProps {
  value: number;
}

const RetailMatchBreakoutItemBar = (
    props: IRetailMatchBreakoutItemBarProps
) => {
    return (
        <BreakoutItemBarOuter>
            <BreakoutItemBarInner value={props.value}></BreakoutItemBarInner>
        </BreakoutItemBarOuter>
    );
};

export default RetailMatchBreakoutItemBar;
